import { Grid, Stack } from '@mui/material';
import { useFormState } from 'react-final-form';

// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  Select,
  Box,
  ProductGroupSelectField,
  TextField,
  CurrencyInputField,
} from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferSelect } from '@occc-app/routes/CampaignComponents/components/OfferSelect';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import {
  qualifyingEventCountProductsBySelectOptions,
  qualifyingEventTypeSelectOptions,
} from './qualifying-event-configuration-form.constants';
import { useMakeOffersFilter } from './use-make-offers-filter.hook';

import {
  ReferralProgramConfigurationValuesPaths,
  ReferralProgramConfigurationValues,
} from '../../referral-program-configuration.types';

export const QualifyingEventConfigurationForm = () => {
  const { values } = useFormState<ReferralProgramConfigurationValues>();
  const makeOffersFilter = useMakeOffersFilter();

  return (
    <Stack spacing={2}>
      <Typography variant='h6'>When Receiver</Typography>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Select
              name={'qualifyingEvent.type' satisfies ReferralProgramConfigurationValuesPaths}
              data={qualifyingEventTypeSelectOptions}
            />
          </Grid>
          {values.qualifyingEvent.type === 'loyaltyEvent' && (
            <Grid item xs={6}>
              <OfferSelect
                makeOffersFilter={makeOffersFilter}
                label='Loyalty Event'
                name={
                  'qualifyingEvent.loyaltyEventOffer' satisfies ReferralProgramConfigurationValuesPaths
                }
              />
            </Grid>
          )}
        </Grid>
      </Box>
      {values.qualifyingEvent.type === 'transaction' && (
        <>
          <Typography variant='h6'>Products Purchased</Typography>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <ProductGroupSelectField
                  label='Eligible product groups'
                  inputProps={{
                    margin: 'none',
                  }}
                  name={
                    'qualifyingEvent.transaction.productGroups' satisfies ReferralProgramConfigurationValuesPaths
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Select
                  label='Count Product by'
                  name={
                    'qualifyingEvent.transaction.countProductsBy' satisfies ReferralProgramConfigurationValuesPaths
                  }
                  data={qualifyingEventCountProductsBySelectOptions}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                {values.qualifyingEvent.transaction.countProductsBy ===
                Constraint_Purchase_Threshold_Counting_Attribute.MoneyAmount ? (
                  <CurrencyInputField
                    label='Threshold'
                    name={
                      'qualifyingEvent.transaction.purchaseThreshold' satisfies ReferralProgramConfigurationValuesPaths
                    }
                    valueType='cents'
                  />
                ) : (
                  <TextField
                    label='Threshold'
                    name={
                      'qualifyingEvent.transaction.purchaseThreshold' satisfies ReferralProgramConfigurationValuesPaths
                    }
                    type='number'
                    fieldProps={{ parse: (value) => parseNumber(value as string) }}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </Stack>
  );
};
